import MonacoEditor, {
    ChangeHandler,
    DiffChangeHandler,
    MonacoDiffEditor,
    MonacoDiffEditorProps
} from "react-monaco-editor";
import * as React from "react";
import rlangFormat from "../../constants/rlangFormat";
import monokai from "../../constants/themes/monokai";
// @ts-ignore
import { initVimMode } from 'monaco-vim';
import { Button, Checkbox, message } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface IState {
    editor: any;
    vimMode: any;
    diffMode: boolean;
    editMode: boolean;
}

class ResizeableMonacoEditor extends React.PureComponent<IResizeableMonacoEditorProps, IState> {
    constructor(props: IResizeableMonacoEditorProps) {
        super(props);
        let editMode = (this.props.editMode !== undefined) ? this.props.editMode : true;
        this.state = {
            editor: null,
            vimMode: null,
            diffMode: false,
            editMode: editMode,
        }
    }

    componentDidUpdate = (props: IResizeableMonacoEditorProps) => {
        this.handleResize()
    }

    handleEditorDidMount = (editor: any) => {
        this.setState({
            editor: editor
        })
    }

    handleResize = () => {
        if (this.state.editor) {
            this.state.editor.layout();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    editorWillMount = (monaco: any) => {
        monaco.languages.register({ id: "rlang" });
        monaco.languages.setMonarchTokensProvider("rlang", rlangFormat);
        monaco.editor.defineTheme("monokai", monokai);

    }

    options = {
        selectOnLineNumbers: true
    };

    toggleVim = (e: CheckboxChangeEvent) => {
        try {
            if (e.target.checked) {
                const status = document.getElementById('vim-statusbar')
                if (status) {
                    status.innerHTML = ""
                }
                const vimMode = initVimMode(this.state.editor, status)
                this.setState({ vimMode: vimMode })
            } else {
                this.state.vimMode.dispose()
            }
        } catch (e: any) {
            message.error(e.toString())
        }
    }

    toggleDiffMode = (e: CheckboxChangeEvent) => {
        this.setState((prev: IState) => {
            return {
                diffMode: !prev.diffMode
            }
        })
    }

    toggleEditMode = (e: CheckboxChangeEvent) => {
        this.setState((prev: IState) => {
            return {
                editMode: !prev.editMode
            }
        })
    }

    render() {
        // console.log("ResizeableMonacoEditor render........", this.props.language)
        let options = {
            ...this.options,
            ...this.props.options
        }
        if (this.props.diffEditorProps && this.props.diffEditorProps.options) {
            options = {
                ...options,
                ...this.props.diffEditorProps.options,
                readOnly: !this.state.editMode,
            }
        }

        return (
            <React.Fragment>
                <Checkbox checked={this.state.editMode} onChange={this.toggleEditMode}>Edit</Checkbox>
                {this.props.diffMode && this.state.diffMode ?
                    <React.Fragment>
                        <Checkbox onChange={this.toggleDiffMode}>Diff</Checkbox>
                        <MonacoDiffEditor
                            height="100%"
                            language={this.props.language}
                            theme={this.props.theme}
                            original={this.props.original}
                            value={this.props.value}
                            options={options}
                            onChange={this.props.onDiffChange}
                            editorDidMount={this.handleEditorDidMount}
                            editorWillMount={this.editorWillMount}
                        />
                    </React.Fragment>
                    :
                    <React.Fragment>
                        {this.props.diffMode && <Checkbox onChange={this.toggleDiffMode}>Diff</Checkbox>}
                        <Checkbox onChange={this.toggleVim}>Vim</Checkbox>
                        <div id={"vim-statusbar"} />
                        <MonacoEditor
                            height="100%"
                            language={this.props.language}
                            theme={this.props.theme}
                            value={this.props.value}
                            options={options}
                            onChange={this.props.onChange}
                            editorDidMount={this.handleEditorDidMount}
                            editorWillMount={this.editorWillMount}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

export interface IResizeableMonacoEditorProps {
    diffEditorProps?: MonacoDiffEditorProps
    options?: {
        readOnly?: boolean;
    };
    value: string;
    original?: string;
    diffMode?: boolean;
    theme?: string;
    language?: string;
    onChange?: ChangeHandler;
    onDiffChange?: DiffChangeHandler;
    size?: number; // used to update the layout
    active?: string; // used to update the layout
    editMode?: boolean;
};

export default ResizeableMonacoEditor;